import React from "react"
import { TextInput } from "@mantine/core"
import { ForgeRockCallbackProps } from "@models/forgeRock.model"

export const NameCallbackInput: React.FC<ForgeRockCallbackProps> = ({
	callback,
	index,
	currentStepNumber,
	callbackValues,
	updateCallbackValue,
	isLoading,
	hasError,
	loginFormComponentData
}) => {
	const prompt = callback.getPrompt?.() || ""
	const existingValue = (callbackValues[index] ??
		callback.getInputValue?.() ??
		"") as string
	const shouldDisableInputs = isLoading

	return (
		<TextInput
			key={`username-${index}-step-${currentStepNumber}`}
			placeholder={loginFormComponentData?.username || prompt}
			value={existingValue}
			onChange={(event) =>
				updateCallbackValue(index, event.currentTarget.value)
			}
			disabled={shouldDisableInputs}
			variant="login"
			aria-label={loginFormComponentData?.username || prompt}
			error={hasError}
			data-qa="ushome.input.username"
		/>
	)
}
